import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LocalStorageService } from './modules/browser-manager-data/local-storage.service';
import { catchError } from 'rxjs/operators';
import { EMPTY, throwError as observableThrowError } from 'rxjs';
import * as HttpStatus from 'http-status-codes';
import { NavigationService } from './modules/navigation/navigation.service';
import { EnvironmentsEnum } from '../environments/environments.enum';
import { environment } from '../environments/environment';

export const TRANSLATION_REFRESH_KEY = 'i2g_missing_translation_refresh';
export const TRANSLATION_PREFIX = './assets/i18n/';
export const TRANSLATION_SUFFIX = '.json';

/**
 * Refresh page once if translation is not found
 */
export class RefreshTranslateHttpLoader extends TranslateHttpLoader {
  constructor(
    private _localStorageService: LocalStorageService,
    private _navigationService: NavigationService,
    httpClient: HttpClient,
    prefix: string,
    suffix: string
  ) {
    super(httpClient, prefix, suffix);
  }

  getTranslation(lang: string): any {
    return super.getTranslation(lang).pipe(
      catchError((error) => {
        if (error.status === HttpStatus.NOT_FOUND) {
          // check previous refresh to prevent infinite reload
          const hasRefreshed = this._localStorageService.getItem(
            TRANSLATION_REFRESH_KEY
          );

          if (!hasRefreshed) {
            this._localStorageService.setItem(TRANSLATION_REFRESH_KEY, true);

            this._navigationService.refresh();

            return EMPTY;
          }
        }

        return observableThrowError(error);
      })
    );
  }
}

// exporting factory required for AOT
export function createTranslateLoader(
  httpClient: HttpClient,
  localStorageService: LocalStorageService,
  navigationService: NavigationService
) {
  // translation files are renamed with version suffix for [ qa, staging, rc, prod ] envs during jenkins deployment
  const suffix = [
    EnvironmentsEnum.integration,
    EnvironmentsEnum.quality,
    EnvironmentsEnum.staging,
    EnvironmentsEnum.production,
  ].includes(environment.env)
    ? `_${environment.version.split('.').join('_')}`
    : '';

  return new RefreshTranslateHttpLoader(
    localStorageService,
    navigationService,
    httpClient,
    TRANSLATION_PREFIX,
    `${suffix}${TRANSLATION_SUFFIX}`
  );
}

export const TRANSLATE_CONFIG: any = {
  loader: {
    provide: TranslateLoader,
    useFactory: createTranslateLoader,
    deps: [HttpClient, LocalStorageService, NavigationService],
  },
};
